import { PermissionsEnum } from "@/auth/interfaces";
import {
  EstadoFactibilidadCorporativaENUM,
  hasPermission,
  ROUTER_PATHS,
  TABLE_CONSTANTS_COLUMS,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared";
import { useFetchGetfactibilidadCorporativos } from "@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions";
import { GeneralTable } from "@/shared/components/ui";
import { useTableColumnsCapacidadCorporativo } from "@/shared/hooks/useTableColumnsCapacidadCorporativo";
import {
  CondicionVentaCorporativa,


  // TipoPlanCorporativo,
} from "@/shared/interfaces";
// import { useAuthStore } from "@/store/auth";
import { Visibility } from "@mui/icons-material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { VerDocumentosHabilitantesContractuales } from "../../shared/componente";
import { IFactibilidadCorporativo } from "@/shared/interfaces/erp/factibilidad_corporativo";

interface SolicitudesPendientesCorporativosTableMainProps {
  estado_factibilidad?: string;
  aceptado_factibilidad?: boolean;
  preaprobado_inventario?: boolean;
  // revisado_contabilidad?:boolean;
  canEditGlobal?: boolean;
}
export default function SolicitudesPendientesCorporativosTableMain({
  estado_factibilidad = EstadoFactibilidadCorporativaENUM.EN_GESTION,
  aceptado_factibilidad = true,
  preaprobado_inventario = true,
  // revisado_contabilidad=true,
  canEditGlobal = true,
}: SolicitudesPendientesCorporativosTableMainProps) {
  const navigate = useNavigate();
 console.log('estado', estado_factibilidad)
  // const username = useAuthStore((s) => s.user)?.username;
  const [open, setOpen] = useState(false);
  const [documentsArray, setDocumentsArray] = useState<any>({});

  ///* table
  const { pagination, setPagination } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  ///* fetch data
  // const {
  //   data: ivasPagingRes,
  //   isLoading,
  //   isRefetching,
  // } = useGetCapacidadCorporativo({
  //   page: pageIndex + 1,
  //   page_size: pageSize,
  //   nombre: searchTerm,
  //   ...filterObject,
  //   filterByState: false,
  // });
  const {
    data: factCoorporativaPagingRes,
    isLoading: isLoadingFactCoorporativa,
    isRefetching: isRefetchingFactCoorporativa,
  } = useFetchGetfactibilidadCorporativos({
    page: pageIndex + 1,
    page_size: pageSize,
    ...filterObject,
    filterByState: false,
    estado_factibilidad: estado_factibilidad,
    aceptado_factibilidad: aceptado_factibilidad,
    preaprobado_inventario: preaprobado_inventario,
    // condicion_venta_isnull_or_void: true,
    condicion_venta_isnull_or_void_or_in:CondicionVentaCorporativa.EVENTO_PAGADO,
    // revisado_contabilidad:revisado_contabilidad,

    // estado_factibilidad:EstadoFactibilidadCorporativaENUM.EN_GESTION,
    // revisado_contabilidad:true,
  });

  const { columnsSolucionCosteada } = useTableColumnsCapacidadCorporativo({setOpen, setDocumentsArray});

  return (
    <>
      <GeneralTable<IFactibilidadCorporativo>
        columns={columnsSolucionCosteada}
        data={factCoorporativaPagingRes?.data?.data || []}
        //
        editIcon={<Visibility />}
        toolTipTitleEditIcon="Revisar"
        isLoading={isLoadingFactCoorporativa}
        isRefetching={isRefetchingFactCoorporativa}
        // // search
        enableGlobalFilter={false}
        // // filters - llega al back
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        enableSorting={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={factCoorporativaPagingRes?.data?.count}
        // // actions ========
        enableColumnActions={hasPermission(
          PermissionsEnum.api_change_factibilidadcoorporativa
        )}
        actionsColumnSize={TABLE_CONSTANTS_COLUMS.ACTIONCOLUMN_WIDTH}
        positionActionsColumn="first"
        // crud
        // TODO - Improve implementation
        canEditByRowData={(_): boolean =>
          canEditGlobal &&
          hasPermission(PermissionsEnum.api_change_factibilidadcoorporativa) 
          // &&        
          // (
          //   (
          //     (
          //       row.preventa_corporativa_data?.tipo_plan == TipoPlanCorporativo.ISP ||
          //       row.preventa_corporativa_data?.tipo_plan == TipoPlanCorporativo.DEMO_ISP ||
          //       row.preventa_corporativa_data?.tipo_plan == TipoPlanCorporativo.CORPORATIVO2 ||
          //       row.preventa_corporativa_data?.tipo_plan == TipoPlanCorporativo.DEMO_CORPORATIVO2 
          //     ) &&
          //     hasPermission(PermissionsEnum.api_probar_isp_user)
          //     && hasPermission(PermissionsEnum.api_probar_isp_demo_user)
          //   ) 
          //   || 
          //   (
          //     row.preventa_corporativa_data?.tipo_plan != TipoPlanCorporativo.ISP &&
          //     row.preventa_corporativa_data?.tipo_plan != TipoPlanCorporativo.CORPORATIVO2 
          //     // &&
          //     // username 
          //     && !hasPermission(PermissionsEnum.api_probar_isp_user)
          //     && !hasPermission(PermissionsEnum.api_probar_isp_demo_user)
          //   )
          // )
        }
        onEdit={(value) => {
          console.log({ value });
          navigate(
            `${
              ROUTER_PATHS.ventasCorporativas.solicitudesPendientesCorporativoNav
            }/${value.id_factibilidad_coorporativa!}`
          );
        }}
        canDelete={false}
      />
      <VerDocumentosHabilitantesContractuales
        open={open}
        setOpen={setOpen}
        documentsArray={documentsArray}
      />
    </>
  );
}
